import { useState } from 'react';
import { useDropzone } from 'react-dropzone';
import { Box, Typography } from '@mui/material';
import colors from './colors';
import { HorizontalLayoutUI } from './HorizontalLayout';
import { IconUI } from './IconUI';
import { onClickHandler } from './utilities/click_handler';

export type ImageUploadProps = {
  onSelect: (value: React.SetStateAction<File[]>) => void
};

export const ImageUploadUI: React.FC<ImageUploadProps> = ({ onSelect }) => {
  const [uploadedImages, setUploadedImages] = useState<File[]>([]);

  const onDrop = (acceptedFiles: File[]) => {
    setUploadedImages(prev => [...prev, ...acceptedFiles]);
    onSelect(prev => [...prev, ...acceptedFiles]);
  };

  const { getRootProps, getInputProps, isDragActive } = useDropzone({
    onDrop,
    accept: {
      'image/png': ['.png'],
    },
  });

  return (
    <HorizontalLayoutUI gap={5}>
      <Box
        {...getRootProps()}
        sx={{
          flexShrink: 0,
          borderStyle: 'dashed',
          borderWidth: '2px',
          borderColor: colors.greige,
          borderRadius: '2px',
          height: 95,
          width: 95,
          display: 'flex',
          flexDirection: 'column',
          alignItems: 'center',
          justifyContent: 'center',
          textAlign: 'center',
          cursor: 'pointer',
          backgroundColor: isDragActive ? 'rgba(0, 0, 0, 0.05)' : 'transparent',
          marginBottom: 2,
        }}
      >
        <input {...getInputProps()} />
        <Typography color="textSecondary">
          {isDragActive ? 'Drop files here...' : 'Upload'}
        </Typography>
        <IconUI name="upload" />
      </Box>
      <HorizontalLayoutUI gap={5} overflow="scroll">
        {uploadedImages.map((file, index) => (
          <Box
            key={index}
            sx={{
              flexShrink: 0,
              width: 95,
              height: 95,
              overflow: 'hidden',
            }}
            onClick={onClickHandler(() => {
              setUploadedImages(prev => prev.filter((_, i) => i !== index));
              onSelect(prev => prev.filter((_, i) => i !== index));
            })}
          >
            <img
              src={URL.createObjectURL(file)}
              alt={`Uploaded file ${index + 1}`}
              style={{
                width: '100%',
                height: '100%',
                objectFit: 'cover',
              }}
            />
          </Box>
        ))}
      </HorizontalLayoutUI>
    </HorizontalLayoutUI>
  );
};
